'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.applicationError = exports.discountCodeState = exports.validated = exports.summary = exports.getSnapshot = exports.optionsFound = undefined;
var _reselect = require('reselect');
var _formOptions = require('@marmalade/marker-study/lib/form-options');
var _constants = require('./constants');
var optionsFound = exports.optionsFound = (0, _reselect.createSelector)(function (state) {
  return (0, _formOptions.options)(state).ownerRelation;
}, function (state) {
  return (0, _formOptions.options)(state).title;
}, function (state) {
  return (0, _formOptions.options)(state).keptOvernight;
}, function (state) {
  return (0, _formOptions.options)(state).employmentStatus;
}, function (owner, title, kept, emp) {
  return !!owner && !!title && !!kept && !!emp;
});
var getSnapshot = exports.getSnapshot = function getSnapshot(state, id) {
  return state[_constants.NAME].snapshots[id];
};
var summary = exports.summary = function summary(state, id) {
  return state[_constants.NAME].summary[id];
};
var validated = exports.validated = function validated(state) {
  return state[_constants.NAME].validated.renewalStage1 && state[_constants.NAME].validated.renewalStage2 && state[_constants.NAME].validated.renewalStage3 && state[_constants.NAME].validated.renewalStage4;
};
var discountCodeState = exports.discountCodeState = function discountCodeState(state) {
  return state[_constants.NAME].discountCode;
};
var applicationError = exports.applicationError = function applicationError(state) {
  return state[_constants.NAME].error;
};